<template>

  <div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:true}"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      class="j-table-force-nowrap"
      :customRow="customRow"
      :customHeaderRow="customHeaderRow"
      @change="handleTableChange">

    </a-table>

  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { checkHasPer } from "@/utils/authFilter"

  export default {
    name: 'PlatformDriverTable',
    mixins:[JeecgListMixin, mixinDevice],
    components: {

    },
    props: {
      model:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        columns: [
          {
            title: '司机ID',
            dataIndex: 'id',
            align:"center",
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title: '客户姓名',
            dataIndex: 'driverName',
            align:"center",
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title:'手机号',
            align:"center",
            dataIndex: 'phone',
            customRender:function (t,r,index) {
              return t || '-';
            }
          },
          {
            title:'绑定时间',
            align:"center",
            dataIndex: 'bdTime',
            customRender:function (t,r,index) {
              return t || '-';
            }
          }
        ],
        url: {
          list: "/dm/dmPlatformGmv/list"
        },disableMixinCreated:true,
        checkHasPer:checkHasPer
      }
    },methods:{
      loadList(){
        this.dataSource = [
          {
            id:this.model.driver.id,
            driverName:this.model.driver.driverName,
            phone:this.model.driver.phone,
            bdTime:this.model.bdTime
          }
        ]

      },customRow(record){
        let that = this;
        let clas = "row-class"
        return {
          class:clas,
          on:{
            click:(e)=>{
              console.log(record)
              if(!that.checkHasPer("view:platform:driverInfo")){
                return;
              }
              that.$emit("view",record.id)
            }
          }
        }

      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/dm/newTable.less';
  /deep/ .hui-class td{
    color: #91929e !important;
  }
</style>